import { BaseViewModel } from "../../ViewModel/Base/BaseViewModel";
import { ICorrelation } from "../../ViewModel/Utilities";
import { BaseCache, ICacheableItem } from "./BaseCache";

export interface IHaveCachableData { }

export class MemoryCache extends BaseCache<BaseViewModel> {


    public constructor(
        config: {
            doReadFN: (id: string) => Promise<any>,
            doDeleteFN: (id: string) => Promise<void>,
            debugName?: string,
            skipCache: boolean
        }
    ) {
        const writeFN: (data: ICacheableItem) => Promise<any> =
            (_data) => { return Promise.resolve() }

        var _config = {
            ...config,
            doWriteFN: writeFN
        }
        super(_config);
        this._derivedType = 'MemoryCache';
    }

    public GetAllIds(): string[] {
        return Array.from(this._itemCache.keys());
    }

    public GetAllitems(): BaseViewModel[] {
        return Array.from(this._itemCache.values());
    }

    public HasCachedItem(_correlation: ICorrelation, id: string): boolean {
        return this._itemCache.has(id);
    }

    public forEach() {
        return this._itemCache.forEach;
    }





    protected GetCacheItem(_correlation: ICorrelation, id: string): BaseViewModel | undefined {
        return this._itemCache.get(id);
    }

    protected SetCacheItem(_correlation: ICorrelation, id: string, item: BaseViewModel) {
        this._itemCache.set(id, item);
    }

    protected DeleteCacheItem(_correlation: ICorrelation, id: string, _skipFlush: boolean = false) {
        this._itemCache.delete(id);
    }

    public ClearCache(): void {
        this._itemCache.clear();
    }

    protected FlushCache(): void {
        return;
    }

    protected RestoreCache(): void {
        return;
    }



    private _itemCache = new Map<string, BaseViewModel>();
}


